import React from "react";

function MaterialFilterBar({
	searchTerm,
	minPrice,
	maxPrice,
	onSearchChange,
	onMinPriceChange,
	onMaxPriceChange,
	onClearFilters,
}) {
	return (
		<div className="material-filter-bar">
			<div className="filter-field">
				<label htmlFor="materialSearch">Search</label>
				<input
					id="materialSearch"
					type="text"
					placeholder="Name contains..."
					value={searchTerm}
					onChange={(event) => onSearchChange(event.target.value)}
				/>
			</div>
			<div className="filter-field">
				<label htmlFor="minPrice">Min $/SqFt</label>
				<input
					id="minPrice"
					type="number"
					step="0.01"
					min="0"
					placeholder="0.00"
					value={minPrice}
					onChange={(event) => onMinPriceChange(event.target.value)}
				/>
			</div>
			<div className="filter-field">
				<label htmlFor="maxPrice">Max $/SqFt</label>
				<input
					id="maxPrice"
					type="number"
					step="0.01"
					min="0"
					placeholder="0.00"
					value={maxPrice}
					onChange={(event) => onMaxPriceChange(event.target.value)}
				/>
			</div>
			<div className="filter-actions">
				<button type="button" onClick={onClearFilters}>
					Clear Filters
				</button>
			</div>
		</div>
	);
}

export default MaterialFilterBar;